import React, { useState, useEffect } from 'react';
import { IntlProvider } from 'react-intl';
import BrandLoader from '@pedidosya/web-fenix/animations/PeyaLoader';

export const getMessages = (locale) => import(`@root/build/translations/${locale}.json`);

export const createIntlProvider =
  (locale, getMessages) =>
  ({ initialMessages, children }) => {
    const [messages, setMessages] = useState(initialMessages);

    const setNoMessages = () => setMessages([]);

    useEffect(() => {
      if (messages) return;
      getMessages(locale).then(setMessages).catch(setNoMessages);
    }, [messages]);

    if (!messages) return <BrandLoader position="center" />;

    return (
      <IntlProvider messages={messages} locale={locale} defaultLocale="es">
        {children}
      </IntlProvider>
    );
  };
